<template>
  <QIcon :color="currentColor" :size="size">
    <svg width="90" height="34" viewBox="0 0 90 34" xmlns="http://www.w3.org/2000/svg">
      <path
        id="test"
        d="M74.3695 22.41C72.5534 22.41 71.0741 23.8894 71.0741 25.7054C71.0741 27.5215 72.5534 29.0009 74.3695 29.0009C76.1856 29.0009 77.665 27.5215 77.665 25.7054C77.665 23.8894 76.1856 22.41 74.3695 22.41ZM74.3695 26.4553C73.9563 26.4553 73.6247 26.1186 73.6247 25.7105C73.6247 25.3024 73.9614 24.9657 74.3695 24.9657C74.7776 24.9657 75.1143 25.3024 75.1143 25.7105C75.1143 26.1186 74.7776 26.4553 74.3695 26.4553Z"
        :fill="currentColor ? undefined : 'url(#icon0_linear)'"
      />
      <path
        d="M17.4283 22.4304C15.6224 22.4304 14.1481 23.8995 14.1481 25.7105C14.1481 27.5215 15.6173 28.9907 17.4283 28.9907C19.2393 28.9907 20.7084 27.5215 20.7084 25.7105C20.7084 23.8995 19.2393 22.4304 17.4283 22.4304ZM17.4283 26.4349C17.0253 26.4349 16.6988 26.1084 16.6988 25.7054C16.6988 25.3024 17.0253 24.9759 17.4283 24.9759C17.8313 24.9759 18.1578 25.3024 18.1578 25.7054C18.1578 26.1084 17.8313 26.4349 17.4283 26.4349Z"
        :fill="currentColor ? undefined : 'url(#icon1_linear)'"
      />
      <path
        d="M89.7143 17.9616C84.2712 11.1309 68.9927 9.80455 66.3961 9.62601C52.4031 0.341565 43.6543 0.326262 35.1861 0.310958C34.2627 0.310958 33.3343 0.310958 32.4059 0.295654C32.3446 0.295654 32.2783 0.295654 32.2171 0.295654C24.6824 0.295654 14.2247 6.86618 12.2096 8.18233H3.75163C3.04764 8.18233 2.47629 8.75368 2.47629 9.45766V15.7374L0.374537 17.8392C0.0939635 18.1197 -0.0437727 18.5176 0.0123421 18.9156L1.17545 27.394C1.26217 28.0265 1.80291 28.4959 2.44058 28.4959H5.9401C6.64409 28.4959 7.21544 27.9245 7.21544 27.2205C7.21544 26.5166 6.64409 25.9452 5.9401 25.9452H3.55267L2.62933 19.1961L4.65456 17.1709C4.89433 16.9311 5.02696 16.6097 5.02696 16.268V10.733H12.5922C12.8473 10.733 13.0922 10.6565 13.3013 10.5136C13.4187 10.4371 24.9477 2.7392 32.3701 2.84122C33.3139 2.85653 34.2474 2.85653 35.1861 2.85653C43.7053 2.87183 51.7501 2.88714 65.2687 11.9318C65.4575 12.0593 65.6819 12.1308 65.9115 12.1461C66.0747 12.1563 82.0317 13.0796 87.4493 19.2165V26.8787H85.5006C84.7966 26.8787 84.2253 27.4501 84.2253 28.1541C84.2253 28.8581 84.7966 29.4294 85.5006 29.4294H88.7247C89.4286 29.4294 90 28.8581 90 28.1541V18.7523C90 18.4615 89.9031 18.181 89.7245 17.9565L89.7143 17.9616Z"
        :fill="currentColor ? undefined : 'url(#icon2_linear)'"
      />
      <path
        d="M63.6821 26.8839H28.8043C28.1003 26.8839 27.5289 27.4552 27.5289 28.1592C27.5289 28.8632 28.1003 29.4345 28.8043 29.4345H63.6821C64.3861 29.4345 64.9575 28.8632 64.9575 28.1592C64.9575 27.4552 64.3861 26.8839 63.6821 26.8839Z"
        :fill="currentColor ? undefined : 'url(#icon3_linear)'"
      />
      <path
        d="M17.4283 17.7167C13.0208 17.7167 9.43451 21.303 9.43451 25.7105C9.43451 30.1181 13.0208 33.7043 17.4283 33.7043C21.8359 33.7043 25.4221 30.1181 25.4221 25.7105C25.4221 21.303 21.8359 17.7167 17.4283 17.7167ZM17.4283 31.1486C14.4287 31.1486 11.9852 28.705 11.9852 25.7054C11.9852 22.7059 14.4287 20.2623 17.4283 20.2623C20.4279 20.2623 22.8714 22.7059 22.8714 25.7054C22.8714 28.705 20.4279 31.1486 17.4283 31.1486Z"
        :fill="currentColor ? undefined : 'url(#icon4_linear)'"
      />
      <path
        d="M74.3695 17.7167C69.9619 17.7167 66.3757 21.303 66.3757 25.7105C66.3757 30.1181 69.9619 33.7043 74.3695 33.7043C78.777 33.7043 82.3633 30.1181 82.3633 25.7105C82.3633 21.303 78.777 17.7167 74.3695 17.7167ZM74.3695 31.1486C71.3699 31.1486 68.9264 28.705 68.9264 25.7054C68.9264 22.7059 71.3699 20.2623 74.3695 20.2623C77.3691 20.2623 79.8126 22.7059 79.8126 25.7054C79.8126 28.705 77.3691 31.1486 74.3695 31.1486Z"
        :fill="currentColor ? undefined : 'url(#icon5_linear)'"
      />
      <path
        d="M59.8766 11.9318C59.8766 11.2278 59.3052 10.6565 58.6012 10.6565H44.3277L42.129 6.26425C41.8127 5.63678 41.0475 5.38171 40.42 5.6929C39.7926 6.00918 39.5375 6.77438 39.8487 7.40184L41.476 10.6565H26.978L23.254 8.27928C22.6572 7.90178 21.8716 8.07522 21.4941 8.66698C21.1166 9.25873 21.29 10.0494 21.8818 10.4269L25.9169 13.0031C26.121 13.1358 26.3608 13.2021 26.6005 13.2021H58.5961C59.3001 13.2021 59.8715 12.6307 59.8715 11.9267L59.8766 11.9318Z"
        :fill="currentColor ? undefined : 'url(#icon6_linear)'"
      />
      <defs>
        <linearGradient id="icon0_linear" x1="45" y1="0.295654" x2="45" y2="33.7043" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
        <linearGradient id="icon1_linear" x1="45" y1="0.295654" x2="45" y2="33.7043" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
        <linearGradient id="icon2_linear" x1="45" y1="0.295654" x2="45" y2="33.7043" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
        <linearGradient id="icon3_linear" x1="45" y1="0.295654" x2="45" y2="33.7043" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
        <linearGradient id="icon4_linear" x1="45" y1="0.295654" x2="45" y2="33.7043" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
        <linearGradient id="icon5_linear" x1="45" y1="0.295654" x2="45" y2="33.7043" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
        <linearGradient id="icon6_linear" x1="45" y1="0.295654" x2="45" y2="33.7043" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
      </defs>
    </svg>
  </QIcon>
</template>

<script>
import { QIcon } from 'quasar';
export default {
  name: 'SedanIcon',
  props: {
    color: {
      type: String
    },
    size: {
      type: String
    }
  },
  data() {
    return {
      currentColor: this.color
    };
  },
  watch: {
    color(value) {
      this.currentColor = value;
    }
  },
  components: { QIcon }
};
</script>
